import { cx } from '@linaria/core';
import { useRef, Suspense } from 'react';
import { FocusOn, FloatingActionButton, CrossIcon } from '@ui/kit';
import { SizeTransition, CSSRefTransition } from '@utils/react';
import { SubNavigation } from './sub-navigation.js';
import { wrapperCls, EXPAND_COLLAPSE_DURATION_MS, subNavigationCls, focusOn, scrollWrapper, closeButtonCls, backdropCls } from './sub-navigation.mobile.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const MobileSubNavigation = ({
  enabled,
  subNavigationRoot,
  currentPageDescriptor,
  rootRef,
  collapseNavigation
}) => {
  const buttonRef = useRef(null);
  return /*#__PURE__*/jsxs("div", {
    className: wrapperCls,
    children: [/*#__PURE__*/jsx(SizeTransition, {
      axis: "vertical",
      in: enabled,
      classNames: subNavigationCls,
      timeout: EXPAND_COLLAPSE_DURATION_MS,
      mountOnEnter: true,
      unmountOnExit: true,
      nodeRef: rootRef,
      delayMs: 10,
      children: ref => /*#__PURE__*/jsx("div", {
        ref: ref,
        className: subNavigationCls,
        children: /*#__PURE__*/jsx(Suspense, {
          fallback: null,
          children: /*#__PURE__*/jsx(FocusOn, {
            className: focusOn,
            onEscapeKey: collapseNavigation,
            onClickOutside: collapseNavigation,
            focusLock: true,
            allowPinchZoom: true
            // eslint-disale-next-line jsx-a11y/no-autofocus
            ,
            autoFocus: true,
            returnFocus: {
              preventScroll: true
            },
            preventScrollOnFocus: true,
            shards: [buttonRef],
            children: /*#__PURE__*/jsx("div", {
              className: scrollWrapper,
              children: /*#__PURE__*/jsx(SubNavigation, {
                currentPageDescriptor: currentPageDescriptor,
                pageDescriptor: subNavigationRoot,
                onLinkClick: collapseNavigation
              })
            })
          })
        })
      })
    }), /*#__PURE__*/jsx(CSSRefTransition, {
      in: enabled,
      classNames: closeButtonCls,
      timeout: EXPAND_COLLAPSE_DURATION_MS,
      mountOnEnter: true,
      unmountOnExit: true,
      nodeRef: buttonRef,
      children: ref => /*#__PURE__*/jsx("div", {
        ref: ref,
        className: cx(closeButtonCls, enabled && "active"),
        children: /*#__PURE__*/jsx(FloatingActionButton, {
          "aria-label": "Luk navigation",
          onClick: collapseNavigation,
          tooltip: {
            placement: "right",
            body: "Luk",
            ariaType: "label"
          },
          children: /*#__PURE__*/jsx(FloatingActionButton.Icon, {
            children: /*#__PURE__*/jsx(CrossIcon, {
              height: "20"
            })
          })
        })
      })
    }), /*#__PURE__*/jsx("div", {
      className: cx(backdropCls, enabled && "visible"),
      role: "none"
    })]
  });
};

export { MobileSubNavigation };
//# sourceMappingURL=sub-navigation.mobile.js.map
